<template>
  <div class="toast" v-show="isShow">
    <div class="loading-icon" v-show="type === 'loading'">
      <img src="https://s.kcimg.cn/bigCarMall/image/loading.gif" />
    </div>
    <i class="icon icon-success" v-show="type === 'success'"></i>
    <i class="icon icon-error" v-show="type === 'error'"></i>
    <i class="icon icon-warn" v-show="type === 'warn'"></i>
    <p class="text-content">{{ text }}</p>
  </div>
</template>
<script>
export default {
  props: {
    isShow: {
      default: false
    },
    text: {
      default: '加载中..'
    },
    time: {
      default: 1000
    },
    type: {
      default: 'loading'
    }
  },
  data: () => ({})
}
</script>
<style scoped>
.toast {
  position: fixed;
  z-index: 9999;
  padding: 10px;
  min-width: 100px;
  min-height: 100px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(17, 17, 17, 0.7);
  text-align: center;
  border-radius: 5px;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
.icon {
  margin-top: 10px;
  font-family: 'dealer';
  color: #fff;
  font-size: 30px;
}
.loading-icon {
  width: 30px;
  height: 30px;
  background: transparent;
  margin: 15px auto 5px;
}
.loading-icon img {
  width: 30px;
  height: 30px;
  vertical-align: middle;
  object-fit: cover;
  text-align: center;
}
.icon-success:before {
  content: '\e754';
}
.icon-error:before {
  content: '\e6d1';
}
.icon-warn::before {
  content: '\e6b7';
}
.text-content {
  margin: 0 0 15px;
}
</style>



// WEBPACK FOOTER //
// src/plugins/ShowToast/Toast.vue